import Vue from 'vue'
import VueRouter from 'vue-router'

import Home from '@/views/Home'
import Sandbox from '@/views/Sandbox'
import Profile from '@/views/Profile'
import Market from '@/views/Market'

import LessonsRoutes from './subroutes/lessons'
import TasklistRoutes from './subroutes/tasklist'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: Home
  },
  {
    path: '/sandbox',
    name: 'sandbox',
    component: Sandbox
  },
  {
    path: '/profile',
    name: 'profile',
    component: Profile
  },
  {
    path: '/market',
    name: 'market',
    component: Market
  },
  {
    path: '/lessons',
    component: () => import(/* webpackChunkName: "lessons" */ '@/views/Lessons'),
    children: LessonsRoutes,
  },
  {
    path: '/tasklist',
    component: () => import(/* webpackChunkName: "tasklist" */ '@/views/Tasklist'),
    children: TasklistRoutes,
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior() {
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve({ x: 0, y: 0 })
      }, 300)
    })
  },
  routes
})

export default router
